/* Brameho - kleurstalen repareren.
   Zet optiewaarden om naar echte kleuren. Waarden die geen kleur zijn
   (Display 24 Pieces, 3-Pack, Penis Face, 10 Euro, ...) worden een
   leesbare tekst-pil in plaats van een leeg wit rondje. */
(function () {
  if (window.__bhSwatchFix) return;
  window.__bhSwatchFix = 1;

  var C = {
    black: '#151515', zwart: '#151515', noir: '#151515',
    white: '#ffffff', wit: '#ffffff', blanc: '#ffffff',
    red: '#dc2626', rood: '#dc2626', rouge: '#dc2626', redpassion: '#c81d25',
    blue: '#2563eb', blauw: '#2563eb', bleu: '#2563eb',
    green: '#16a34a', groen: '#16a34a', vert: '#16a34a',
    yellow: '#f5c518', geel: '#f5c518',
    orange: '#f97316', oranje: '#f97316',
    purple: '#7c3aed', paars: '#7c3aed', violet: '#7c3aed',
    pink: '#ec4899', roze: '#ec4899', rosa: '#ec4899',
    rose: '#f43f5e',
    gray: '#9ca3af', grey: '#9ca3af', grijs: '#9ca3af',
    brown: '#8b5a2b', bruin: '#8b5a2b',
    gold: '#d4af37', goud: '#d4af37',
    silver: '#c8ccd0', zilver: '#c8ccd0',
    beige: '#e7d3b6', nude: '#e6c7a8', cream: '#f6ecd8', creme: '#f6ecd8',
    bronze: '#cd7f32', brons: '#cd7f32', copper: '#b87333',
    cyan: '#06b6d4', turquoise: '#14b8a6', teal: '#0d9488', aqua: '#22d3ee',
    navy: '#1e3a8a', marine: '#1e3a8a',
    bordeaux: '#6d071a', bordeux: '#6d071a', burgundy: '#6d071a', wine: '#6d071a',
    flesh: '#f0c6a0', huidskleur: '#f0c6a0', skin: '#f0c6a0',
    salmon: '#fa8072', zalm: '#fa8072',
    lila: '#c084fc', lilac: '#c084fc', lavender: '#b39ddb', lavendel: '#b39ddb',
    mint: '#8fd6b4', olive: '#7d8b2f', olijf: '#7d8b2f', khaki: '#b9a06a',
    cherry: '#b3121c', kers: '#b3121c',
    strawberry: '#e8384f', aardbei: '#e8384f',
    banana: '#ffe135', banaan: '#ffe135',
    wasabi: '#8fbc45',
    chocolate: '#5b3a29', chocolade: '#5b3a29',
    vanilla: '#f3e5ab', vanille: '#f3e5ab',
    peach: '#ffcba4', perzik: '#ffcba4', rosegold: '#b76e79',
    clear: 'CLEAR', transparant: 'CLEAR', transparent: 'CLEAR', helderdoorzichtig: 'CLEAR'
  };

  var SPECIAL = {
    rainbow: 'RAINBOW', regenboog: 'RAINBOW', multicolour: 'RAINBOW',
    multicolor: 'RAINBOW', multi: 'RAINBOW', gekleurd: 'RAINBOW',
    leopard: 'LEOPARD', panter: 'LEOPARD', luipaard: 'LEOPARD', panther: 'LEOPARD',
    camo: 'CAMO', camouflage: 'CAMO',
    glow: 'GLOW'
  };

  var DARK = ['dark', 'donker', 'deep', 'diep', 'donkere'];
  var LIGHT = ['light', 'licht', 'baby', 'ice', 'pastel', 'soft', 'lichte'];

  var NOISE = ['colour', 'color', 'colours', 'colors', 'kleur', 'kleuren', 'farbe',
    'couleur', 'stone', 'matt', 'mat', 'glitter', 'mix', 'met', 'with', 'and',
    'en', 'the', 'de', 'een', 'a', 'in', 'of', 'w', 'reflected', 'metallic',
    'shiny', 'glans', 'box', 'helder'];

  function inList(arr, t) { return arr.indexOf(t) >= 0; }

  function shade(hex, amt) {
    var h = hex.replace('#', '');
    var r = parseInt(h.substring(0, 2), 16);
    var g = parseInt(h.substring(2, 4), 16);
    var b = parseInt(h.substring(4, 6), 16);
    function m(v) {
      if (amt < 0) return Math.round(v * (1 + amt));
      return Math.round(v + (255 - v) * amt);
    }
    return 'rgb(' + m(r) + ',' + m(g) + ',' + m(b) + ')';
  }

  function lookup(tok, mod) {
    var base = C[tok];
    var extraMod = 0;
    if (base === undefined) {
      var i, p;
      for (i = 0; i < DARK.length; i++) {
        p = DARK[i];
        if (tok.length > p.length && tok.substring(0, p.length) === p && C[tok.substring(p.length)] !== undefined) {
          base = C[tok.substring(p.length)]; extraMod = -1; break;
        }
      }
      if (base === undefined) {
        for (i = 0; i < LIGHT.length; i++) {
          p = LIGHT[i];
          if (tok.length > p.length && tok.substring(0, p.length) === p && C[tok.substring(p.length)] !== undefined) {
            base = C[tok.substring(p.length)]; extraMod = 1; break;
          }
        }
      }
    }
    if (base === undefined) return null;
    if (base === 'CLEAR') return 'CLEAR';
    var m = mod || extraMod;
    if (m < 0) return shade(base, -0.35);
    if (m > 0) return shade(base, 0.38);
    return base;
  }

  var PHRASES = [
    ['bordeaux red', 'bordeaux'], ['bordeaux rood', 'bordeaux'],
    ['salmon pink', 'salmon'], ['zalm roze', 'salmon'],
    ['pink gold', 'rosegold'], ['rose gold', 'rosegold'], ['roze goud', 'rosegold'],
    ['glow in the dark', 'glow'],
    ['huid kleur', 'flesh']
  ];

  function parse(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return null;
    var low = s.toLowerCase();
    for (var q = 0; q < PHRASES.length; q++) {
      if (low.indexOf(PHRASES[q][0]) >= 0) low = low.split(PHRASES[q][0]).join(PHRASES[q][1]);
    }
    var sep = ['/', '&', '+', ',', ';', '-', '(', ')', ':', '.'];
    for (var i = 0; i < sep.length; i++) low = low.split(sep[i]).join(' ');
    var parts = low.split(' ');
    var cols = [], special = null, leftover = 0, mod = 0;
    for (var j = 0; j < parts.length; j++) {
      var t = parts[j].trim();
      if (!t) continue;
      if (inList(NOISE, t)) continue;
      if (inList(DARK, t)) { mod = -1; continue; }
      if (inList(LIGHT, t)) { mod = 1; continue; }
      if (SPECIAL[t]) { special = SPECIAL[t]; mod = 0; continue; }
      var c = lookup(t, mod);
      if (c) { cols.push(c); mod = 0; continue; }
      leftover++;
      mod = 0;
    }
    if (!cols.length && !special) return { pure: false, fill: null, clear: false };
    return { pure: leftover === 0, cols: cols, special: special, leftover: leftover };
  }

  var RAINBOW = 'conic-gradient(#dc2626,#f97316,#f5c518,#16a34a,#06b6d4,#2563eb,#7c3aed,#ec4899,#dc2626)';

  function applyFill(el, r, asDot) {
    var st = el.style;
    st.backgroundImage = '';
    st.backgroundSize = '';
    st.backgroundPosition = '';
    st.boxShadow = '';
    var needsRing = false;
    var sp = (r.cols && r.cols.length >= 2) ? null : r.special;
    if (sp === 'RAINBOW') {
      st.background = RAINBOW;
    } else if (sp === 'LEOPARD') {
      st.background = '#d9a441';
      st.backgroundImage = 'radial-gradient(#4a2c17 30%, transparent 32%), radial-gradient(#4a2c17 30%, transparent 32%)';
      st.backgroundSize = '7px 7px';
      st.backgroundPosition = '0 0, 3.5px 3.5px';
    } else if (sp === 'CAMO') {
      st.background = '#6b7a3a';
      st.backgroundImage = 'radial-gradient(#3f4a22 34%, transparent 36%), radial-gradient(#b9a06a 30%, transparent 32%)';
      st.backgroundSize = '9px 9px';
      st.backgroundPosition = '0 0, 4.5px 4.5px';
    } else if (sp === 'GLOW') {
      st.background = '#c8f56a';
      st.boxShadow = '0 0 6px rgba(163,230,53,0.9)';
    } else if (r.cols.length === 1 && !sp) {
      if (r.cols[0] === 'CLEAR') {
        st.background = 'linear-gradient(135deg,#ffffff 0 50%,#dfe3e8 50% 100%)';
        needsRing = true;
      } else {
        st.background = r.cols[0];
        if (r.cols[0] === '#ffffff') needsRing = true;
      }
    } else if (r.cols.length === 0) {
      st.background = '#e5e7eb';
    } else {
      var list = [], k, n = Math.min(r.cols.length, 4), step = 100 / n;
      for (k = 0; k < n; k++) {
        var cc = r.cols[k] === 'CLEAR' ? '#f1f3f5' : r.cols[k];
        list.push(cc + ' ' + (k * step) + '% ' + ((k + 1) * step) + '%');
        if (cc === '#ffffff') needsRing = true;
      }
      st.background = 'linear-gradient(135deg,' + list.join(',') + ')';
    }
    if (needsRing) {
      st.boxShadow = (st.boxShadow ? st.boxShadow + ',' : '') + 'inset 0 0 0 1px rgba(0,0,0,0.18)';
    }
    if (asDot) { st.borderColor = 'rgba(0,0,0,0.12)'; }
  }

  function dotFor(r) {
    var d = document.createElement('span');
    d.className = 'bh-sw-dot';
    applyFill(d, r, true);
    return d;
  }

  /* ---------- kaarten ---------- */
  function doCards(root) {
    var list = root.querySelectorAll('.b2b-card__swatch:not([data-bh-sw])');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      el.setAttribute('data-bh-sw', '1');
      var val = el.getAttribute('data-color') || '';
      if (!val) { continue; }
      var r = parse(val);
      if (r && r.pure) {
        el.style.backgroundColor = '';
        applyFill(el, r, false);
        continue;
      }
      el.classList.add('b2b-card__swatch--pill');
      el.style.backgroundColor = '';
      el.style.background = '';
      el.textContent = val;
      if (r && r.cols && (r.cols.length || r.special)) {
        el.insertBefore(dotFor(r), el.firstChild);
      }
    }
    capPills(root);
  }

  /* Brede tekst-pillen mogen de kaart niet uit elkaar trekken:
     toon er hooguit vier en tel de rest op in een "+N" label. */
  function capPills(root) {
    var boxes = root.querySelectorAll('.b2b-card__swatches:not([data-bh-cap])');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var pills = box.querySelectorAll('.b2b-card__swatch--pill');
      if (!pills.length) continue;
      box.setAttribute('data-bh-cap', '1');
      var kids = box.children, shown = 0, hidden = 0;
      for (var j = 0; j < kids.length; j++) {
        if (kids[j].className && String(kids[j].className).indexOf('bh-sw-more') >= 0) continue;
        if (shown < 4) { shown++; continue; }
        kids[j].style.display = 'none';
        hidden++;
      }
      if (hidden > 0) {
        var more = document.createElement('span');
        more.className = 'bh-sw-more';
        more.textContent = '+' + hidden;
        more.title = hidden + ' more';
        box.appendChild(more);
      }
    }
  }

  /* ---------- productpagina ---------- */
  function doProduct(root) {
    var list = root.querySelectorAll('.b2bp__opt-btn--color:not([data-bh-sw])');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      el.setAttribute('data-bh-sw', '1');
      var val = el.getAttribute('title') || '';
      if (!val) continue;
      var r = parse(val);
      if (r && r.pure) {
        el.style.backgroundColor = '';
        applyFill(el, r, false);
        continue;
      }
      el.classList.remove('b2bp__opt-btn--color');
      el.classList.add('b2bp__opt-btn--text');
      el.removeAttribute('style');
      el.textContent = val;
      if (r && r.cols && (r.cols.length || r.special)) {
        el.insertBefore(dotFor(r), el.firstChild);
      }
    }
  }

  /* Opties die geen kleuroptie heten maar wel een kleur noemen
     (bijvoorbeeld een optie "Model" met de waarde Pink) krijgen
     hun tekst plus een klein gekleurd bolletje. */
  function doOtherPills(root) {
    var sel = '.b2b-card__other-pill:not([data-bh-sw]), .b2bp__opt-btn:not(.b2bp__opt-btn--color):not(.b2bp__opt-btn--text):not([data-bh-sw])';
    var list = root.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      el.setAttribute('data-bh-sw', '1');
      var val = el.getAttribute('data-other-val') || el.getAttribute('title') || el.textContent;
      val = String(val || '').split('(out of stock)').join('').trim();
      if (!val) continue;
      var r = parse(val);
      if (!r || !r.pure) continue;
      el.insertBefore(dotFor(r), el.firstChild);
      el.classList.add('bh-sw-tinted');
    }
  }

  function css() {
    if (document.getElementById('bh-sw-css')) return;
    var s = document.createElement('style');
    s.id = 'bh-sw-css';
    s.textContent = [
      '.b2b-card__swatch--pill{width:auto!important;height:auto!important;min-width:0!important;',
      'border-radius:999px!important;padding:.15rem .6rem!important;font-size:1.05rem;line-height:1.45;',
      'font-weight:600;color:#374151;background:#f3f4f6!important;border:1px solid #e5e7eb!important;',
      'display:inline-flex;align-items:center;gap:.4rem;white-space:nowrap;max-width:12rem;',
      'overflow:hidden;text-overflow:ellipsis;box-shadow:none!important}',
      '.b2b-card__swatch--pill.b2b-card__swatch--oos{opacity:.5;text-decoration:line-through}',
      '.bh-sw-dot{flex:0 0 auto;width:.9rem;height:.9rem;border-radius:50%;display:inline-block;',
      'border:1px solid rgba(0,0,0,.12)}',
      '.b2bp__opt-btn--text{padding:.55rem 1.1rem;display:inline-flex;align-items:center;gap:.5rem}',
      '.b2bp__opt-btn--text .bh-sw-dot{width:1.1rem;height:1.1rem}',
      '.b2b-card__swatches{flex-wrap:wrap}',
      '.bh-sw-more{font-size:1.05rem;font-weight:600;color:#6b7280;align-self:center}',
      '.bh-sw-tinted{display:inline-flex;align-items:center;gap:.4rem}'
    ].join('');
    document.head.appendChild(s);
  }

  function run() {
    css();
    try { doCards(document); } catch (e) {}
    try { doProduct(document); } catch (e) {}
    try { doOtherPills(document); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(); }, 120);
  });
  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
